import React from "react";
import { useAsset } from "../../hooks/activos/useAsset";
import { Divider, Grid } from "@mui/material";
import { convertirLetraMayus } from "../../helpers/convertirLetraMayus";
import dayjs from "dayjs";
import { Background } from '../../svg/Background';
import { makeStyles } from '@mui/styles';

export const Asset = () => {

    const { asset } = useAsset();
    const classes = useStyles();

	return (    
        <Grid container className={ classes.container }>
            <Background style={{ position: 'fixed', height: '100dvh', filter: 'blur(5px)' }} />
            <Grid 
                item
                direction='column'
                xs={ 12 } sm={ 12 } md={ 3 } lg={ 3 }
                className={ classes.row }
            >
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 20, height: '40vh', background: '#00365F', position: 'sticky' }}>
                    <img src={ require('../../assets/img/logo_blanco.png') } alt="logo" style={{ width: 100, position: 'absolute', top: 8, left: 10 }} />
                    
                    <div style={{ position: 'absolute', top: -20, right: -20, opacity: .05 }}>
                        <div style={{ width: 100, height: 100, background: '#fff', borderRadius: '50%' }} />
                        <div style={{ width: 50, height: 50, background: '#fff', borderRadius: '50%' }} />
                    </div>

                    <img
                        src={ asset?.imagen?.secure_url || require('../../assets/img/placeholder.png') }
                        alt="imagen" 
                        style={{ width: '25vw', maxWidth: 150, height: '25vw', maxHeight: 150, borderRadius: '50%', border: '2px solid #fff' }} 
                    />

                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 5 }}>
                        <label style={{ fontWeight: 600, fontSize: 'clamp(.5rem, 1.3vw + 1rem, 1rem)', color: '#fff', letterSpacing: .8, }}>Placa: 
                            <span style={{ fontWeight: 500, marginLeft: 5, fontSize: 'clamp(.5rem, 1.3vw + 1rem, 1rem)', color: '#fff' }}>{ asset?.placa }</span>
                        </label>

                        <label style={{ fontWeight: 600, fontSize: 'clamp(.5rem, 1.3vw + 1rem, 1rem)', color: '#fff', letterSpacing: .8 }}>Responsable: 
                            <span style={{ fontWeight: 500, marginLeft: 5, fontSize: 'clamp(.5rem, 1.3vw + 1rem, 1rem)', color: '#fff' }}>{ convertirLetraMayus(asset?.responsable?.usuario?.nombre, true) }</span>
                        </label>

                        <label style={{ fontWeight: 600, fontSize: 'clamp(.5rem, 1.3vw + 1rem, 1rem)', color: '#fff', letterSpacing: .8 }}>Asignado: 
                            <span style={{ fontWeight: 500, marginLeft: 5, fontSize: 'clamp(.5rem, 1.3vw + 1rem, 1rem)', color: '#fff' }}>{ dayjs(asset?.responsable?.fecha_asignacion).format('DD-MM-YYYY') }</span>
                        </label>

                    </div>
                </div>

                <div style={{ padding: '25px 25px 25px 25px', display: 'flex', flexDirection: 'column', rowGap: 20, position: 'relative', height: '60vh', overflowY: 'auto', scrollbarWidth: 'none', background: '#fff' }}>
                    <label style={{ fontWeight: 600, textAlign: 'justify', fontSize: 'clamp(.5rem, 1.3vw + 1rem, 1rem)', padding: 0, letterSpacing: .8 }}>Descripción:
                        <span style={{ fontWeight: 'normal', marginLeft: 5, fontSize: 'clamp(.5rem, 1.3vw + 1rem, 1rem)' }}>{ convertirLetraMayus(asset?.descripcion) }.</span>
                    </label>

                    <Divider />

                    <label style={{ fontWeight: 600, textAlign: 'justify', fontSize: 'clamp(.5rem, 1.3vw + 1rem, 1rem)', padding: 0, letterSpacing: .8 }}>Ubicación:
                        <span style={{ fontWeight: 'normal', marginLeft: 5, fontSize: 'clamp(.5rem, 1.3vw + 1rem, 1rem)' }}>{ convertirLetraMayus(asset?.ubicacion) }.</span>
                    </label>

                    <Divider />

                    <label style={{ fontWeight: 600, textAlign: 'justify', fontSize: 'clamp(.5rem, 1.3vw + 1rem, 1rem)', padding: 0, letterSpacing: .8 }}>Categoría:
                        <span style={{ fontWeight: 'normal', marginLeft: 5, fontSize: 'clamp(.5rem, 1.3vw + 1rem, 1rem)' }}>{ convertirLetraMayus(asset?.categoria?.nombre) }.</span>
                    </label>
                </div>
            </Grid>
        </Grid>
    );
}

const useStyles = makeStyles({
    container: {
        overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 20,
        height: '100vh',
        '@media(max-width: 850px)': {
            padding: 0
        }
    },
    row: {
        borderRadius: 16, overflow: 'hidden',
        height: '100vh',
        '@media(max-width: 850px)': {
            borderRadius: 0
        }
    }
});